import React from "react";
import { ReactComponent as InstructIconOne } from "../../../assets/instructIconOne.svg";
import { ReactComponent as InstructIconTwo } from "../../../assets/instructIconTwo.svg";
import { ReactComponent as InstructIconThree } from "../../../assets/instructIconThree.svg";
import { ReactComponent as BgOne } from "../../../assets/instructOneBg.svg";
import { ReactComponent as BgTwo } from "../../../assets/instructTwoBg.svg";
import { ReactComponent as BgThree } from "../../../assets/instructThreeBg.svg";
import { ReactComponent as MobileBgOne } from "../../../assets/MobileBGOne.svg";
import { ReactComponent as MobileBgTwo } from "../../../assets/MobileBGTwo.svg";
import { ReactComponent as MobileBgThree } from "../../../assets/MobileBGThree.svg";

const Instruct = () => {
  return (
    <div className="container-wrapper instruct-section-wrapper">
      <h1 className="header text-center">
        Filing a claim has never been easier
      </h1>
      <div className="instruct-card-wrapper desktop-wrapper">
        <div className="instruct-card instruct-card-bg1">
          <BgOne
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: "-1",
            }}
          />

          <InstructIconOne />
          <div className="text-wrapper">
            <p className="card-step-text">Step 1</p>
            <p className="cart-text">Submit your claim</p>
            <p className="cart-sub-text">
              Fill out our easy online form with details of your flight.
            </p>
          </div>
        </div>

        <div className="instruct-card instruct-card-bg2">
          <BgTwo
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: "-1",
            }}
          />

          <InstructIconTwo />
          <div className="text-wrapper">
            <p className="card-step-text">Step 2</p>
            <p className="cart-text">We will handle the process</p>
            <p className="cart-sub-text">
              Our legal team negotiates directly with the airline
            </p>
          </div>
        </div>

        <div className="instruct-card instruct-card-bg3">
          <BgThree
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: "-1",
            }}
          />

          <InstructIconThree />
          <div className="text-wrapper">
            <p className="card-step-text" style={{ color: "#222222" }}>
              Step 3
            </p>
            <p className="cart-text" style={{ color: "#314064" }}>
              Get Paid
            </p>
            <p className="cart-sub-text" style={{ color: "#565A6D" }}>
              Once your claim is approved, the compensation is transferred
              directly to you.
            </p>
          </div>
        </div>
      </div>

      {/* mobile  */}

      <div className="instruct-card-wrapper mobile-wrapper">
        <div className="instruct-card instruct-card-bg1">
          <MobileBgOne
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: "-1",
            }}
          />
          <span className="mobile-instructon-icon-wrapper">
            <InstructIconOne />
          </span>
          <div className="text-wrapper">
            <p className="card-step-text">Step 1</p>
            <p className="cart-text">Submit your claim</p>
            <p className="cart-sub-text">
              Fill out our easy online form with details of your flight.
            </p>
          </div>
        </div>

        <div className="instruct-card instruct-card-bg2">
          <MobileBgTwo
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: "-1",
            }}
          />

          <span className="mobile-instructon-icon-wrapper">
            <InstructIconTwo />
          </span>
          <div className="text-wrapper">
            <p className="card-step-text">Step 2</p>
            <p className="cart-text">We will handle the process</p>
            <p className="cart-sub-text">
              Our legal team negotiates directly with the airline
            </p>
          </div>
        </div>

        <div className="instruct-card instruct-card-bg3">
          <MobileBgThree
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: "-1",
            }}
          />

          <span className="mobile-instructon-icon-wrapper">
            <InstructIconThree />
          </span>
          <div className="text-wrapper">
            <p className="card-step-text" style={{ color: "#222222" }}>
              Step 3
            </p>
            <p className="cart-text" style={{ color: "#314064" }}>
              Get Paid
            </p>
            <p className="cart-sub-text" style={{ color: "#565A6D" }}>
              Compensation is transferred directly to you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instruct;
